<template>
  <div>
      <div v-if="isShow" class="modal">
          <div class="ibox">
            <!-- 申请、入住表 -->
            <div v-show="!isShowSuccess">
                <p class="title">项目申请</p>
                <form  class="form-group" autocomplete="off" @submit.prevent="validateBeforeSubmit">
                    <!-- 项目名称 -->
                    <input class="input-text" type="text" placeholder="项目名称" v-validate = "'required'" v-model="applySend.project_name" name="project">
                    <span class="inputred" v-show="errors.has('project')">{{ errors.first('project') }}</span>
                    <!-- 姓名 -->
                    <input v-model="applySend.name" class="input-text" type="text" placeholder="姓名" v-validate = "'required'" name="name">
                    <span class="inputred" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                    <!-- 手机号 -->
                    <input v-model="applySend.phone" class="input-text" type="text" placeholder="手机号"  v-validate = "'required|mobiles'" name="phone">
                    <span class="inputred" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                    <!-- 邮箱 -->
                    <input v-model="applySend.email" class="input-text" type="text" placeholder="邮箱" v-validate = "'required|email'"  name = "email">
                    <span class="inputred" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                    <!-- APP或网站名称 -->
                    <input v-model="applySend.app_name" class="input-text" type="text" placeholder="网址或者网APP名称" v-validate = "'required'"  name = "app_name">
                    <span class="inputred" v-show="errors.has('app_name')">{{ errors.first('app_name') }}</span>
                    <!-- 邮箱 -->
                    <input v-model="applySend.description" class="input-text" type="text" placeholder="请详细描述接入后展示的位置（10 字以上）" v-validate = "'required|description'"  name = "description">
                    <span class="inputred" v-show="errors.has('description')">{{ errors.first('description') }}</span>
                    <div class="choose-type">
                        <label role="checkbox" class="el-checkbox is-checked" aria-checked="true">
                            <span aria-checked="mixed" class="el-checkbox__input is-checked">
                                <span :class="apply ? 'el-checkbox__inner' : 'el-checkbox_nochosed'"></span>
                                <input type="checkbox"  v-model="apply" class="el-checkbox__original" value="">
                            </span>
                            <span class="el-checkbox__label">申请使用</span>
                        </label>

                        <label role="checkbox" class="el-checkbox is-checked" aria-checked="true">
                            <span aria-checked="mixed" class="el-checkbox__input is-checked">
                                <span :class="checkin ? 'el-checkbox__inner' : 'el-checkbox_nochosed'"></span>
                                <input type="checkbox"  v-model="checkin" class="el-checkbox__original" value="">
                            </span>
                            <span class="el-checkbox__label">我要入驻</span>
                        </label>
                    </div>
                    <p class="inputred" v-show="errorInfo">{{errorInfo}}</p>
                    <div class="button">
                        <button class="cursor commit" type="submit" v-if="!isLoading">立即申请</button>
                        <span class="cursor commit" v-else>申请中...</span>
                        <div class="cursor cancel" @click="cancel">取消</div>
                    </div>
                </form >
            </div>
            <!-- 成功提示 -->
            <div v-show="isShowSuccess">
                <div class="success-img">
                    <img src="data:image/png;base64,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"/>
                </div>
                <div class="success-title">
                    您的申请已提交
                </div>
                <p class="success-describe">2个工作日内我们将会把API KEY发送</p>
                <div class="close-view">
                    <button @click="cancel" class="close cursor">关闭</button>
                </div>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
/**
 * 申请接入模态框
 *
 * @requires HomeBanner.vue TypeContent.vue,
 * @author liguojie
 */
import applyApi from '@/http/api/v1/topic'
export default {
  props: [
    'isShow',
    'type'
  ],
  components: {
  },
  name: 'ApplicationAccess',
  data () {
    return {
      isShowSuccess: false, // 显示成功提示
      errorInfo: '', // 入住申请复选错误提示
      apply: false,
      checkin: false,
      applySend: { // 申请API参数
        project_name: '',
        email: '',
        name: '',
        phone: '',
        apply_type: '',
        app_name: '',
        description: '',
        company_id: 1, // 公司id默认为1金色
        project_id: 0 // 项目id默认为0
      },
      isLoading: false
    }
  },
  watch: {
    isShow (newdata, olddata) { // 监听重置选中状态
      if (newdata) {
        if (this.type === 'apply') {
          this.apply = true
          this.checkin = false
        } else if (this.type === 'checkin') {
          this.checkin = true
          this.apply = false
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    cancel () { // 向父组件传值
      this.$emit('listen-is-show', false)
      //  一系列状态清空
      this.errorInfo = '' // 关闭清空提示
      this.isShowSuccess = false
      this.applySend.project_name = ''
      this.applySend.email = ''
      this.applySend.name = ''
      this.applySend.phone = ''
      this.applySend.apply_type = ''
      this.applySend.app_name = ''
      this.applySend.description = ''
      this.$validator.reset()
    },
    regCheckbox () { // 复选错误验证
      if (this.apply && this.checkin) { // 都选中
        this.applySend.apply_type = 3
      } else if (this.apply && !this.checkin) { // 选中申请使用
        this.applySend.apply_type = 1
      } else if (!this.apply && this.checkin) { // 选中申请使用
        this.applySend.apply_type = 2
      } else if (!this.apply && !this.checkin) { // 都未选中
        this.applySend.apply_type = ''
        this.errorInfo = '至少选中一个选项'
        return false
      }
      this.errorInfo = '' // 选中状态正确，清空错误提示
      return true
    },
    validateBeforeSubmit () { // 提交申请
      this.$validator.validateAll().then((result) => {
        var testCheckbox = this.regCheckbox()
        if (result && testCheckbox) {
          this.isLoading = true
          applyApi.getTopicListByTag(this.applySend).then(res => {
            this.isLoading = false
            if (res.status_code === 0) {
              this.isShowSuccess = true
            }
          }).catch(errors => {
            this.isLoading = false
            alert(errors.message)
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.modal{
    width: 100;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    background-color: rgba(0, 0, 0, 0.5);
    .ibox{
        width: 900px;
        min-height: 475px;
        margin: 7% auto 0 auto;
        background: #ffffff;
        padding: 30px;
        box-sizing: border-box;
        .title{
            height:30px;
            font-size:16px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(33,33,42,1);
            line-height:30px;
            margin-bottom: 30px;
        }
        .form-group{
            .input-text{
                width: 840px;
                height: 45px;
                line-height: 45px;
                margin-top: 15px;
                box-sizing: border-box;
                padding: 0 15px;
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                border:1px solid #E2E2E8;
            }
            .input-text:nth-child(1){
                margin-top: 0;
            }
            .inputred{
                color: red;
                cursor: default;
                font-weight: 300;
                font-size: 14px;
            }
            input::-webkit-input-placeholder{
                color:#C2C2C9;
            }
            input::-moz-placeholder{ /* Mozilla Firefox 19+ */
                color:#C2C2C9;
            }
            input:-moz-placeholder{ /* Mozilla Firefox 4 to 18 */
                color:#C2C2C9;
            }
            input:-ms-input-placeholder{ /* Internet Explorer 10-11 */
                color:#C2C2C9;
            }
        }
        .choose-type{
            height: 30px;
            line-height: 30px;
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(33,33,42,1);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 23px;
            .choose{
                height: 30px;
                line-height: 30px;
                margin-right: 30px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                user-select: none;
                .ui-checkbox{
                    color: #606266;
                    font-weight: 500;
                    font-size: 14px;
                    position: relative;
                    cursor: pointer;
                }
            }
            .choose input{
                margin-right: 10px;
                background:rgba(22,125,248,1);
            }
            // elememt ui checkbox
            .el-checkbox {
                color: #606266;
                font-weight: 500;
                font-size: 14px;
                position: relative;
                cursor: pointer;
                display: inline-block;
                white-space: nowrap;
                user-select: none;
                margin-right: 30px;
                .el-checkbox__original{
                    width: 0;
                    height: 0;
                    display: none;
                }
                .el-checkbox_nochosed{
                    display: inline-block;
                    position: relative;
                    border: 1px solid #167DF8;
                    border-radius: 2px;
                    box-sizing: border-box;
                    width: 14px;
                    height: 14px;
                    background-color: #fff;
                    z-index: 1;
                    transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
                }
                .el-checkbox__input {
                    white-space: nowrap;
                    cursor: pointer;
                    outline: none;
                    display: inline-block;
                    line-height: 1;
                    position: relative;
                    vertical-align: middle;
                    margin-right: 10px;
                    .el-checkbox__inner {
                        display: inline-block;
                        position: relative;
                        border: 1px solid #dcdfe6;
                        border-radius: 2px;
                        box-sizing: border-box;
                        width: 14px;
                        height: 14px;
                        background-color: #fff;
                        z-index: 1;
                        transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
                    }
                    .el-checkbox__inner {
                        background-color: #409eff;
                        border-color: #409eff;
                    }
                    .el-checkbox__inner:after {
                        box-sizing: content-box;
                        content: "";
                        border: 1px solid #fff;
                        border-left: 0;
                        border-top: 0;
                        height: 7px;
                        left: 4px;
                        position: absolute;
                        top: 1px;
                        transform: rotate(45deg) scaleY(0);
                        width: 3px;
                        transition: transform .15s ease-in .05s;
                        transform-origin: center;
                        transform: rotate(45deg) scaleY(1);
                    }
                }
            }
        }
        .button{
            height: 40px;
            margin-top: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
            .commit{
                padding: 10px 30px;
                height: 40px;
                text-align: center;
                box-sizing: border-box;
                font-size:14px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                background:rgba(22,125,248,1);
                color:rgba(255,255,255,1);
                margin-right: 10px;
                border: 1px solid rgba(22,125,248,1);
            }
            .commit:hover{
                background:rgba(92,175,249,1);
                border: 1px solid rgba(92,175,249,1);
            }
            .cancel{
                padding: 10px 30px;
                height: 40px;
                text-align: center;
                box-sizing: border-box;
                font-size:14px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                background:rgba(136,136,146,1);
                color:rgba(255,255,255,1);
            }
            .cancel:hover{
                background: rgba(194,194,201,1);
            }
        }
        .success-img{
            margin-top: 75px;
            width: 100px;
            height: 100px;
            margin: 75px auto 30px auto;
            img{
                width: 100px;
                height: 100px;
            }
        }
        .success-title{
            text-align: center;
            font-size:22px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(33,33,42,1);
            margin-bottom: 15px;
        }
        .success-describe{
            height:20px;
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(33,33,42,1);
            line-height:20px;
            text-align: center;
            margin-bottom: 90px;
        }
        .close-view{
            text-align: center;
            .close{
                width: 88px;
                height: 40px;
                background:rgba(22,125,248,1);
                font-size:14px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                color:rgba(255,255,255,1);
                border: 1px solid rgba(22,125,248,1);
                margin: 0 auto;
            }
        }
    }
}
</style>
